import React from "react";
import ReactDOM from "react-dom/client";
import "./global.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import StripeProvider from "./components/AccountComponents/StripeProvider";
import { BrowserRouter as Router } from "react-router-dom";

window.addEventListener("unhandledrejection", (event) => {
  if (event.reason) {
    const errorStr = event.reason.toString();

    if (errorStr.includes("502") || errorStr.includes("Bad Gateway")) {
      event.preventDefault();
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
